import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export interface CreateFlowDataProps {
    title: string;
    flowTriggerId: number;
    distribution: number;
    active: boolean;
}

export const getShopClients = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop-clients`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}